import gql from 'graphql-tag';

export default gql`
  mutation deleteCourseLearningAnswers($courseVersion: String!, $courseId: String!) {
    deleteCourseLearningAnswers(courseVersion: $courseVersion, courseId: $courseId)
  }
`;
